import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


const TermsConditionsPage = () => {
    const navigate = useNavigate();

    // Scroll to the top of the page when the component is loaded
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleHome = () => {
        navigate('/');
    };
    return (
        <>
            <div className="flex flex-col py-10 px-10 2xl:px-96 xl:px-96 md:px-24 bg-white">
            <div className="flex gap-5 mt-6 me-4 mb-16 my-auto" >
                    <button className="focus:border-blue-900 justify-center px-12 py-2 text-lg font-medium text-white bg-blue-900 rounded max-lg:px-5 max-lg:mx-1 me-2" onClick={handleHome}>
                    <i className="fa fa-arrow-left ml-2" style={{ color: '#ffffff' }}></i> {" "}Back to Home
                    </button>
                </div>
                <div className="flex flex-col w-full max-md:mt-10 max-md:max-w-full">
                    <div className="text-3xl font-semibold">
                        Terms & Conditions
                    </div>
                    <div className="flex flex-col mt-2 w-full  max-md:mt-10 max-md:max-w-full">
                        <div className="mt-4 text-lg max-md:max-w-full text-neutral-900">
                            Welcome to Smart Chokidar. By accessing or using the Service, you agree to comply with these Terms and Conditions. Please read them carefully. If you do not agree to these Terms, do not use the Service.
                        </div>
                    </div>
                    <div className="text-3xl font-semibold text-blue-900 mt-12">
                        <span className="text-neutral-900">1. Acceptance of </span>Terms
                    </div>
                    <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                        By using the Service, you confirm that you are at least 18 years old and have the legal capacity to enter into these Terms. Your continued use of the Service constitutes acceptance of these Terms.
                    </div>
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">2. Use of the </span>Service
                </div>
                <div className="flex flex-col grid 2xl:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 mt-6 w-full max-md:max-w-full gap-5">
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className="text-xl font-bold text-neutral-900">
                            A) Permitted&nbsp;<span className="text-blue-900">Use</span>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <div className=" w-full text-semibold max-md:max-w-full">
                                You agree to use the Service only for lawful purposes and in accordance with these Terms. You must not:
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                Use the Service in a way that violates any applicable laws or regulations.                                </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                Attempt to gain unauthorized access to any part of the Service.                                </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                Interfere with the Service's performance or security.                                </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col grid 2xl:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 mt-6 w-full max-md:max-w-full gap-5">
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className="text-xl font-bold text-neutral-900">
                            B) Account&nbsp;<span className="text-blue-900">Responsibility</span>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <div className=" w-full text-semibold max-md:max-w-full">
                                You are responsible for:
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                Maintaining the confidentiality of your account credentials.
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                All activities that occur under your account.
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <div className=" w-full text-semibold max-md:max-w-full">
                                You must notify us immediately of any unauthorized use of your account.
                            </div>
                        </div>
                    </div>
                </div>


                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">3. Fees and </span>Payments
                </div>
                <div className="flex flex-col grid 2xl:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 mt-6 w-full max-md:max-w-full gap-5">
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className="text-xl font-bold text-neutral-900">
                            A) Payment&nbsp;<span className="text-blue-900">Terms</span>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <div className=" w-full text-semibold max-md:max-w-full">
                                Some features of the Service may require payment. You agree to:
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                Provide accurate payment information.
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                Pay all applicable fees as outlined in our pricing policy.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col grid 2xl:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 mt-6 w-full max-md:max-w-full gap-5">
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className="text-xl font-bold text-neutral-900">
                            B) Late&nbsp;<span className="text-blue-900">Payments</span>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <div className=" w-full text-semibold max-md:max-w-full">
                                We reserve the right to suspend or terminate access to the Service for unpaid fees.
                            </div>
                        </div>
                    </div>
                </div>


                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">3. Intellectual </span>Property
                </div>
                <div className="flex flex-col grid 2xl:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 mt-6 w-full max-md:max-w-full gap-5">
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className="text-xl font-bold text-neutral-900">
                            A) Ownership
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <div className=" w-full text-semibold max-md:max-w-full">
                                All content, trademarks, logos, and materials within the Service are the property of Smart Chokidar or its licensors. You may not copy, distribute, or use them without prior written permission.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col grid 2xl:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 mt-6 w-full max-md:max-w-full gap-5">
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className="text-xl font-bold text-neutral-900">
                            B) User&nbsp;<span className="text-blue-900">Content</span>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <div className=" w-full text-semibold max-md:max-w-full">
                                By submitting content to the Service, you grant us a non-exclusive, royalty-free, worldwide license to use, modify, and display the content as necessary to operate the Service.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">5. Termination </span>
                </div>
                <div className="text-lg mt-4 max-md:max-w-full">
                    We reserve the right to suspend or terminate your access to the Service at our sole discretion if you violate these Terms. Upon termination, you must cease using the Service and delete any related content you have obtained.
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">6. Disclaimers </span>
                </div>
                <div className="text-lg mt-4 max-md:max-w-full">
                    The Service is provided "as is" and "as available" without any warranties, express or implied. We do not guarantee that the Service will be uninterrupted or error-free. Your use of the Service is at your own risk.
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">7. Limitation of </span>Liability
                </div>
                <div className="flex flex-col grid 2xl:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 mt-6 w-full max-md:max-w-full gap-5">
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className='flex flex-row items-start gap-2 '>
                            <div className=" w-full text-semibold max-md:max-w-full">
                                To the maximum extent permitted by law, Smart Chokidar and its affiliates are not liable for:
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                Any indirect, incidental, or consequential damages.
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                Loss of data, revenue, or profits arising from your use of the Service.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">8. Indemnification </span>
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    You agree to indemnify and hold harmless Smart Chokidar, its employees, and affiliates from any claims, damages, or expenses arising out of your use of the Service or violation of these Terms.
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">9. Governing </span>Law
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    These Terms are governed by the laws of Ahmedabad, Gujarat. Any disputes arising under these Terms shall be resolved in the courts of Ahmedabad, Gujarat.
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">10. Changes to </span>Terms
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    We reserve the right to modify these Terms at any time. Changes will be effective upon posting. Your continued use of the Service constitutes acceptance of the updated Terms.
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">11. Contact </span>Us
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    If you have questions about these Terms, please contact us:
                </div>

                <div className="text-lg mt-8 font-semibold text-neutral-900 max-md:max-w-full">
                    Headway Business Solutions LLP
                </div>
                <div className="text-lg font-semibold text-neutral-900 max-md:max-w-full">
                    101, Kashi Parekh Complex, B/H Bhagwati Chamber, C G Road, Ahmedabad
                </div>
                <div className="text-lg font-semibold text-neutral-900 max-md:max-w-full">
                    Email : info@headway.org.in
                </div>
                <div className="text-lg font-semibold text-neutral-900 max-md:max-w-full">
                    Contact : +91 90812 41916
                </div>


                <div className="flex gap-5 mt-6 me-4 mb-16 my-auto" >
                <button className="focus:border-blue-900 justify-center px-12 py-2 text-lg font-medium text-white bg-blue-900 rounded max-lg:px-5 max-lg:mx-1 me-2" onClick={handleHome}>
                    <i className="fa fa-arrow-left ml-2" style={{ color: '#ffffff' }}></i> {" "}Back to Home
                    </button>
                </div>
            </div>
        </>
    )
}

export default TermsConditionsPage